import { COLORS } from '../constants/themeConstants'
import { Vehicle } from '../services/rest/ecommerce/dafCompanyVehicles'
import {
  MY_FLEET_LIST_FILTER_VALUE_MAINTENANCE_DUE_IN_ONE_MONTH,
  MY_FLEET_LIST_FILTER_VALUE_MAINTENANCE_DUE_IN_ONE_TO_TWO_MONTHS,
  MY_FLEET_LIST_FILTER_VALUE_MAINTENANCE_OVERDUE,
  SERVICEPLAN_CONTRACT_STATE_CANCELED,
  SERVICEPLAN_CONTRACT_STATE_EXPIRED,
  SERVICEPLAN_CONTRACT_STATE_EXPIRING,
  SERVICEPLAN_CONTRACT_STATE_ON_HOLD,
  VEHICLE_UPGRADE_ATTENTION,
  VEHICLE_UPGRADE_IMPORTANT,
  VEHICLE_UPGRADE_WARNING,
} from '../constants/dafCompanyVehicleConstants'
import { MULTISUPPORT_SITE_CONTEXT } from '../constants/environmentConstants'
import { SiteContext } from '../types/sitecoreContextProps'

export const dafVehicleColorHelper = (vehicle: Vehicle, site: SiteContext) => {
  if (
    vehicle.applicableFilters.maintenance[0] ===
      MY_FLEET_LIST_FILTER_VALUE_MAINTENANCE_OVERDUE ||
    vehicle.applicableFilters.vehicleUpgrade?.[0] === VEHICLE_UPGRADE_WARNING ||
    (site.name === MULTISUPPORT_SITE_CONTEXT &&
      (vehicle.applicableFilters.contractState ===
        SERVICEPLAN_CONTRACT_STATE_ON_HOLD ||
        vehicle.applicableFilters.contractState ===
          SERVICEPLAN_CONTRACT_STATE_EXPIRED ||
        vehicle.applicableFilters.contractState ===
          SERVICEPLAN_CONTRACT_STATE_CANCELED))
  ) {
    return COLORS.ALERT
  }

  if (
    vehicle.applicableFilters.maintenance[0] ===
      MY_FLEET_LIST_FILTER_VALUE_MAINTENANCE_DUE_IN_ONE_MONTH ||
    vehicle.applicableFilters.vehicleUpgrade?.[0] === VEHICLE_UPGRADE_IMPORTANT ||
    (site.name === MULTISUPPORT_SITE_CONTEXT &&
      vehicle.applicableFilters.contractState ===
        SERVICEPLAN_CONTRACT_STATE_EXPIRING)
  ) {
    return COLORS.PROMOTION
  }

  if (
    vehicle.applicableFilters.maintenance[0] ===
      MY_FLEET_LIST_FILTER_VALUE_MAINTENANCE_DUE_IN_ONE_TO_TWO_MONTHS ||
    vehicle.applicableFilters.vehicleUpgrade?.[0] === VEHICLE_UPGRADE_ATTENTION
  ) {
    return COLORS.ORANGE
  }

  return 'transparent'
}
